// lib/hooks/use-modal.ts
import { useState } from "react";
var useModal = (initial = false) => {
  const [isActive, setIsActive] = useState(initial);
  const open = () => setIsActive(true);
  const close = () => setIsActive(false);
  return {
    isActive,
    open,
    close
  };
};

export {
  useModal
};
